export default "<app-first-section-ordenar-compra></app-first-section-ordenar-compra>\r\n"